import { render, staticRenderFns } from "./CommercialStrataMedicalSuite.vue?vue&type=template&id=7c2f8825&scoped=true&"
import script from "./CommercialStrataMedicalSuite.vue?vue&type=script&lang=ts&"
export * from "./CommercialStrataMedicalSuite.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialStrataMedicalSuite.vue?vue&type=style&index=0&id=7c2f8825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2f8825",
  null
  
)

export default component.exports